<template>
	<Dropdown ref="inTree" class="in-tree" :trigger="trigger">
		<Input type="text" :search="!disabled" readonly v-model="data.title" :disabled="disabled" :clearable="true"  @on-focus="getData" @on-change="change"></Input>
		<div slot="list"><Tree :data="treeData" @on-select-change="onSelect"></Tree><load ref='spin' /></div>		
	</Dropdown>
</template>
<script>
export default {
	name: 'in-tree',
	props: {
		data:{//Ĭ����ѡֵ
			type: Object,
            default:() => ({title:'',id:''}) 
		},
		url:{//���ݵ�ַ
			type: String,
			default: ''
		},
		disabled:{//�Ƿ����
			type: Boolean,
            default: false
		},
		query:{//
			type: Object,
            default:() => ({}) 
		}
	},
	data () {
		return {
			treeData:[]
		}
	},
	mounted(){		
	},
	computed: {trigger(){return this.disabled?'custom':'click'}},
	methods: {		
		onSelect (node){//ѡ���¼���������ѡ������			
			const obj = node.length?node[0]:{title:"",id:""};
			this.$emit('callback',obj);
			this.$refs.inTree.handleClick();
		},
		change(){
			if(this.data.title==""&&this.data.id!=""){
				this.$emit('callback',{title:"",id:""});
				this.$refs.inTree.handleClick();
			}
		},
		getData(e){
			this.$refs.spin.spinShow();
			var query = Object.assign({},this.query,{id:this.data.id});
			this.$ajax.post(this.url,query).then(data => {
				if(data.status==this.$ajax.HTTP_S){
					this.treeData = data.result;					
				}
				if(data.status==this.$ajax.HTTP_F) this.$Message.error({content:data.message,closable: true});
				this.$refs.spin.spinHide();
			});	
			let el = e.target;
			el.blur();
		}
	}
}
</script>






// WEBPACK FOOTER //
// src/components/inc/modal/in-tree.vue